
import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';

// import { ElectricityServiceFAKE } from './electricity.service.fake';
// import { StateServiceFAKE } from './state.service.fake';
// import { SmartTableServiceFAKE } from './smart-table.service.fake';
// import { PlayerServiceFAKE } from './player.service';
import { HappyMammaService } from './happymamma.service';

const SERVICES = [
    HappyMammaService,
    // ElectricityServiceFAKE,
    // StateServiceFAKE,
    // SmartTableServiceFAKE,
    // PlayerServiceFAKE,
];

@NgModule({
    imports: [
        CommonModule,
    ],
    providers: [
        ...SERVICES,
    ],
})

export class DataModule {
    static forRoot(): ModuleWithProviders<DataModule> {
        return {
          ngModule: DataModule,
            providers: [
                ...SERVICES,
            ],
        };
    }
}
